__turbopack_context__.v({
  "addToBasket": "add-to-basket-timer-module-scss-module__Yia0_q__addToBasket",
  "addToBasketWrap": "add-to-basket-timer-module-scss-module__Yia0_q__addToBasketWrap",
  "addToBasket__button": "add-to-basket-timer-module-scss-module__Yia0_q__addToBasket__button",
  "addToBasket__dot": "add-to-basket-timer-module-scss-module__Yia0_q__addToBasket__dot",
  "addToBasket__main": "add-to-basket-timer-module-scss-module__Yia0_q__addToBasket__main",
  "addToBasket__progress": "add-to-basket-timer-module-scss-module__Yia0_q__addToBasket__progress",
  "addToBasket__text": "add-to-basket-timer-module-scss-module__Yia0_q__addToBasket__text",
  "dot": "add-to-basket-timer-module-scss-module__Yia0_q__dot",
  "progress": "add-to-basket-timer-module-scss-module__Yia0_q__progress",
  "slideUp": "add-to-basket-timer-module-scss-module__Yia0_q__slideUp",
});
